<template>
<div style="height:100%;">
<div class="height-set-for-component" ref="fadeWhenModelOpen">
    <div style="display:flex">
      <div class="search-bar-comm-style pt-2 col-md-6" style="display: block;">
        <input
            type="text"
            class="rounded text-light search-bar"
            :placeholder="$t('Search screen profile')"
            autocomplete="off" v-model="searchFilters.name" @input="updateMetadataProfileLstFromServer(false)"/>
      </div>
      <div class="primary-btn-style justify-content-end mr-3 pt-2 col-md-6">
        <button class="learn-about-text-styles" @click="openLearnAboutPanel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lightbulb-fill" viewBox="0 0 16 16">
            <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/>
          </svg>{{$t('Learn about screen profile')}}</button>
        <!-- <button class="btn btn-outline-danger mr-2" style="border: 1px solid #831515;" v-on:click="deleteProfile()">Delete</button> -->
          <!-- <button class="btn btn-outline-secondary m-2"  style="border: 1px solid #585858;" v-on:click="editMetadataProfile('metadata-screen-info')">Edit</button> -->
          <button class="btn btn-outline-primary m-2" v-on:click="changeToSelectedMetadataProfileTableComponent('add-screen-profile')">{{$t('Add')}}</button>
      </div>
    </div>
  <div class="pl-4 pt-0 pr-4 pb-2" style="height:calc(100% - 70px);overflow:auto">
    <table class="tabletable-with-border table-scroll small-first-col table-cell-styles" style="background: transparent;width:100% !important">
      <thead style="color: #eee;height: 40px;">
        <tr>
          <th style="width: 20%;text-align:start">{{$t('Name')}}</th>
          <th style="width: 40%;text-align:start">{{$t('Load When')}}</th>
          <th style="width: 40%;text-align:start">{{$t('Fields')}}</th>
          <!-- <th style="width: 10%"></th> -->
        </tr>
      </thead>
      <tbody class="body-half-screen">
        <tr v-for="key in metadataProfileList" :key="key._id" :id="key._id" 
        @click="selectRow(key), changeToSelectedProfileKeyComponent('metadata-screen-info', key)"
        :class="{activeclass: actveCustMetadata == key._id}"
            class="comm-user-row show-delete-icon">
            <!-- @dblclick="changeToSelectedProfileKeyComponent('metadata-screen-info', key)"  -->
          <td class="text-left" style="text-transform: capitalize;width:20%">
            {{key.name }}
          </td>
          <td class="text-left" style="width:40%">
            <div v-for="(loadW,index) in key.load_when" :key="loadW.uuid" style="word-break: break-all;">
              <template v-if="index <= 1">
              <div v-if="loadW.type == 'Catalog' && loadW.id_list.length" class="d-flex">
                <span class="key-div">
                  {{$t('Catalog')}} 
                </span>
                <div style="text-transform: capitalize;" class="ellipsis-to-entry-temp">
                  {{displayCategoryNames(loadW.id_list, loadW.catalog_info)}}
                </div>
              </div>
              <div v-else-if="isFieldType(loadW.type) && loadW.id_list.length">
                <div v-for="fInfo in loadW.id_list" :key="fInfo" class="d-flex">
                  <span v-if='["FREETEXT","FREETEXT_MULTILINE","PICKLIST","PICKLIST_MULTIVALUE"].includes(loadW.type)' class="key-div">
                    {{ displayFieldKeyName(fInfo) + " contains "}}
                  </span>
                  <span v-else-if='["DATE","DATE_TIME"].includes(loadW.type)' class="key-div">
                    {{ displayFieldKeyName(fInfo) + " between "}}
                  </span>
                  <span v-else-if='["INTEGER"].includes(loadW.type)' class="key-div">
                    {{ displayFieldKeyName(fInfo) + " from "}}
                  </span>
                  <div v-if="fInfo.length && ['PICKLIST_MULTIVALUE','PICKLIST'].includes(loadW.type)" style="text-transform: capitalize;" class="ellipsis-to-entry">
                    {{getPicklistValueName(loadW.id_list[0],loadW.value)}}
                  </div>
                  <div v-else-if="fInfo.length && !['INTEGER'].includes(loadW.type)" style="text-transform: capitalize;" class="ellipsis-to-entry">
                    {{getTypeVal(loadW.value, loadW.type)}}
                  </div>

                  <!-- <div v-else-if="fInfo.length" style="text-transform: capitalize;" class="ellipsis-to-entry">
                    {{loadW.value['from']}}
                  </div>
                  <span v-else-if='["INTEGER"].includes(loadW.type)' class="key-div">
                    {{" to "}}
                  </span>
                  <div v-else-if="fInfo.length" style="text-transform: capitalize;" class="ellipsis-to-entry">
                    {{loadW.value['to']}}
                  </div> -->

                  <div v-else-if="typeof(loadW.value) === 'object' && ['INTEGER'].includes(loadW.type)" style="width:65%">
                    <template v-for="(value, key) in loadW.value">
                      <div v-if="key == 'from'" :key="key" style="float:inline-start;padding-inline-start:5px;">
                        {{value }}
                        <span style="color:#757575">
                          {{" to "}}
                        </span>
                      </div>
                      
                      <div v-if="key == 'to'" :key="key" style="padding-inline-start:4px;display:inline-block">
                        {{value}}
                      </div>
                    </template>  
                  </div>
                  <span v-else>
                    None
                  </span>
                </div>
              </div>
              <div v-else-if="loadW.type == 'MimeType' && loadW.value.length" class="d-flex">
                <span class="key-div">
                   {{$t('Mime Type')}}
                </span>
                <div style="text-transform: capitalize;" class="ellipsis-to-entry">
                  {{loadW.value}}
                </div>
              </div>
              <div v-else-if="loadW.type == 'User' && loadW.id_list.length" class="d-flex">
                <span class="key-div">
                  {{$t('User is')}} :
                </span>
                <div style="text-transform: capitalize;" class="ellipsis-to-entry">
                  {{displayUsersName(loadW.id_list)}}
                </div>
              </div>
              <div v-else-if="loadW.type == 'UserGroup' && loadW.id_list.length" class="d-flex">
                <span class="key-div">
                  {{$t('User Group')}}
                </span>
                <div style="text-transform: capitalize;" class="ellipsis-to-entry">
                  {{displayUserGroupsName(loadW.id_list)}}
                </div>
              </div>
              <div v-else-if="loadW.type == 'Screen' && loadW.id_list.length" class="d-flex">
                <span class="key-div">
                  {{$t('Screen is')}}
                </span>
                <div style="text-transform: capitalize;" class="ellipsis-to-entry">
                  {{displayScreensName(loadW.id_list)}}
                </div>
              </div>
              <div v-else-if="loadW.type == 'AdvancedExpression' && loadW.id_list.length" class="d-flex">
                <span class="key-div">
                 {{$t('Advanced Expression matches')}}
                </span>
                <v-breadcrumbs-divider style="text-transform: capitalize;" class="ellipsis-to-entry">
                  {{loadW.id_list[0]}}
                </v-breadcrumbs-divider>
              </div>
              </template>
            </div>
             <template v-if="key.load_when != undefined && key.load_when.length>2">
                <div>+ {{key.load_when.length - 2}} {{$t('More')}}</div>
              </template>
          </td>
          <td class="text-left" style="width:30%">
            <div>
              <span> {{getFieldNames(key.custom_metadata_id_list, key.tag_id_list, key.name)}} </span>
              <a v-if="key.custom_metadata_id_list.length > 3" class="view-more w-25" @click="changeToSelectedProfileKeyComponent('metadata-screen-info', key)"> + {{$t('More')}} ...</a>
            </div>

             <svg  @click.stop.prevent="changeToSelectedProfileKeyComponent('metadata-screen-info', key)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-pencil parent-row-edit" viewBox="0 0 16 16">
              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
            </svg>
            <svg @click.stop.prevent="deleteProfile(key)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-trash parent-row-delete" viewBox="0 0 16 16">
                <title>{{$t('Delete')}}</title>
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
            </svg>
          </td>
          <!-- <td style="position: relative;width:10%"> -->
            <!-- <div class="dropdown">
              <div class="nav-item nav-link dropdown-toggle mr-md-2" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
              <svg width="15" height="1.5em" viewBox="0 0 16 16" class="bi bi-three-dots more-actions-btn"  fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
              </svg>
            </div>
            <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                  <a class="dropdown-item p-2" @click.stop.prevent="deleteMetadataProfile(key._id, key.name)">
                    <svg width="15" height="15" viewBox="0 0 16 16" class="bi bi-trash-fill" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"/>
                    </svg>
                    Delete</a>
            </div>
            </div> -->
            <!-- <svg  @click.stop.prevent="changeToSelectedProfileKeyComponent('metadata-screen-info', key)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-pencil parent-row-edit" viewBox="0 0 16 16">
              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
            </svg>
            <svg @click.stop.prevent="deleteProfile(key)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-trash parent-row-delete" viewBox="0 0 16 16">
                <title>Delete</title>
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
            </svg> -->
          <!-- </td> -->
        </tr>
      </tbody>
    </table>
  </div>
   <div>
    <pagination
        v-model="page"
        :records="totalProfiles"
        :per-page="perPage"
        @paginate="paginate"
        :options="options"
    />
    </div>
</div>
<component :is="selectedComponenet" @close="closeLearnAboutPanel"></component>
</div>
</template>

<script>
import { mapGetters,mapActions,mapMutations } from "vuex";
import {NotifierConstants} from "../../components.constants.js";
import Utils from "../../components.utils.js"
import Pagination from "vue-pagination-2";
import LearnAbout from "./LearnAboutScreenProfiles.vue";
 
export default {
  props:["searchFilters","page"],
  components:{
    pagination: Pagination,
    "learn-about":LearnAbout
  },
  data(){
    return {
      totalPages: -1,
      totalProfiles: -1,
      perPage: -1,
      selectedRowDetails:{},
      actveCustMetadata:null,
      selectedComponenet:null,
      metadataProfileList: [],
      options:{chunk:5},
      tagIdNameList:[],
      categoryIdNameList:[],
      fieldIdNameList:[],
      userIdNameList:[],
      userGroupIdNameList:[],
      screenIdNameList:[]
    };
  },
  methods: {
    //LoadWhen operations
    displayCategoryNames(categoryIdList,catalogPathDetails){
      if(categoryIdList == undefined){
        return
      }
      if(categoryIdList.length <= 0 || this.categoryIdNameList == undefined){
        return "NONE"
      }
      let categoryNameString = []
      let exten = ""
      if(categoryIdList.length > 0){
        let mxCount = 0
        for(let cId of catalogPathDetails){
          if(mxCount >= 2){
            break;
          }
          categoryNameString.push(cId.catalog_name + " [" + 
                                  (Array.isArray(cId.parent_path)?cId.parent_path[0].value.replace("catalog://0",""):cId.parent_path.value.replace("catalog://0","")) + " ]");
          mxCount = mxCount + 1;
        }
        
        if(categoryIdList.length > 2){
          exten = " +" + (categoryIdList.length - 2) + " More";
        }
      }else{
        exten = "NONE"
      }
      return categoryNameString.join(",") + exten;
    },
    isFieldType(fieldType){
      return ["FREETEXT","FREETEXT_MULTILINE","DATE","DATE_TIME","INTEGER","PICKLIST","PICKLIST_MULTIVALUE"].includes(fieldType);
    },
    isFieldExists(fieldId){
      let idx = this.fieldIdNameList.findIndex(item=>item._id == fieldId);
      if(idx >= 0){
        return true;
      }
      return false;
    },
    getCustomMetadataName(fieldInfo){
      if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
        let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
        if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
          return mapperExists.field_alias;
        }
      }
      return fieldInfo.name;
    },
    displayFieldKeyName(fieldId){
      let userMDetails = this.fieldIdNameList.filter((u)=>u._id == fieldId);
      if(userMDetails.length == 1){
        return this.getCustomMetadataName(userMDetails[0]);
      }
      return "NONE";
    },
    displayUsersName(userIdList){
      let userNameList = []
      for(let uId of userIdList){
        if(this.userIdNameList != undefined){
          let uInfo = this.userIdNameList.filter(u=>u.user_id==uId);
          if(uInfo != undefined && uInfo.length > 0){
            userNameList.push(uInfo[0].name);
          }
        }
      }
      return userNameList.join(", ");
    },
    displayUserGroupsName(userGroupIdList){
      let userGroupNameList = []
      for(let uGId of userGroupIdList){
        let uGInfo = this.userGroupIdNameList.filter(u=>u.user_group_id==uGId);
        if(uGInfo != undefined && uGInfo.length > 0){
          userGroupNameList.push(uGInfo[0].name);
        }
      }
      return userGroupNameList.join(", ");
    },
    displayScreensName(screenIdList){
      let screenNameList = []
      for(let sId of screenIdList){
        let sInfo = this.screenIdNameList.filter(s=>s._id==sId);
        if(sInfo != undefined && sInfo.length > 0){
          screenNameList.push(sInfo[0].name);
        }
      }
      return screenNameList.join(", ");
    },
    //
    openLearnAboutPanel(){
      this.selectedComponenet = 'learn-about';
      console.log("selectedComponenetselectedComponenet",this.selectedComponenet)
      this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
      this.$refs.fadeWhenModelOpen.style.pointerEvents = "none";
    },
    closeLearnAboutPanel(){
      this.selectedComponenet = null;
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
      this.$refs.fadeWhenModelOpen.style.pointerEvents = "auto";
    },
    displayTagNames(tagIds){
      let tagsNameString = []
      let exten = ""
      if(tagIds.length > 0){
        let tagName = ""
        let tagDetails = this.tagIdNameList.filter((tag_)=>tag_.tag_id == tagIds[0]);
        if(tagDetails.length == 1){
          tagName = tagDetails[0].name
        }
        if(tagName.length > 0){
          tagsNameString.push(tagName);
        }
        if(tagIds.length != 1){
          exten = " +" + (tagIds.length - 1) + " More";
        }
      }else{
        exten = "NONE"
      }
      return tagsNameString.join(",") + exten;
    },
    displayUserMetadataNames(metadataIdList){
      let customMetadataString = []
      let exten = ""
      if(metadataIdList.length > 0){
        let userMName = ""
        let userMDetails = this.fieldIdNameList.filter((userMetadata_)=>userMetadata_._id == metadataIdList[0]);
        if(userMDetails.length == 1){
          userMName = userMDetails[0].name
        }
        if(userMName.length > 0){
          customMetadataString.push(userMName);
        }
        if(metadataIdList.length != 1){
          exten = " +" + (metadataIdList.length - 1) + " More";
        }
      }else{
        exten = "NONE"
      }
      return customMetadataString.join(",") + exten;
    },
    paginate(pageNo) {
      this.$emit("pageSwitched", pageNo);
      this.page = pageNo;
      this.updateMetadataProfileLstFromServer(true);
    },
    changeToSelectedMetadataProfileTableComponent(compName, payload = {}){
            this.$emit("changeToSelectedMetadataProfileTableComponent", compName, payload)
    },
    getPicklistValueName(fieldId, valIds){
      let valNames = []
      let fieldInfo = this.fieldIdNameList.filter(op=>op._id == fieldId);
      if(fieldInfo.length > 0){
        for(let eachId of valIds){
          let picklistVal = fieldInfo[0].values.filter(op=>op.value_id == eachId)
          if(picklistVal.length > 0){
            valNames.push(picklistVal[0].value)
          }
        }
      }
      return valNames.join(",")
    },
    getTypeVal(val, type){
      if(type == "DATE_TIME"){
        val[0] = val[0].replace("T"," ");
        val[1] = val[1].replace("T"," ");
      }
      return val;
    },
    editMetadataProfile(comp){
      if(this.selectedRowDetails._id != undefined){
        this.changeToSelectedMetadataProfileTableComponent(comp,this.selectedRowDetails)
      }else{
        alert("Select Metadata profile to edit");
        return false;
      }
    },
    deleteProfile(key){
      if(key){
        this.deleteMetadataProfile(key._id,key.name)
      }else{
        alert("Select Screen template to delete");
        return false;
      }
    },
    selectRow(key){
      this.selectedRowDetails = key;
      this.actveCustMetadata = key._id;
    },
    deleteMetadataProfile(keyId, keyName){
      if (confirm(`Are You sure you want to delete the selected "${keyName}" screen profile? `)) {
        let payload={}
        payload.params = { _id: keyId }
        this.deleteExistingMetadataProfile(payload).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)){
            this.$toast.success(data.message);
            this.updateMetadataProfileLstFromServer(true);
          } else{
            this.$toast.error(data.message);
          }
        });
        this.updateMetadataProfileLstFromServer(true)
        this.selectedRowDetails = {}
      }
    },
    changeToSelectedProfileKeyComponent(compName, metadataKeyInfo){
      this.$emit("changeToSelectedProfileKeyComponent", compName, metadataKeyInfo)
    },
    getFieldNames(fieldIds, tagIds){
      let namesList = []
      if(tagIds != undefined && tagIds.length){
        namesList.push("Tags");
      }
      let maxindx = 4;
      if(fieldIds != undefined){
        let i = 0;
        while( i<fieldIds.length){
          if(i >= maxindx){
            break;
          }
          let fDetails = this.fieldIdNameList.filter((userMetadata_)=>userMetadata_._id == fieldIds[i]);
          if(fDetails != undefined && fDetails.length > 0){
            namesList.push(this.getCustomMetadataName(fDetails[0]));
          }else if(['Description','Catalogs'].includes(fieldIds[i])){
            namesList.push(fieldIds[i]);
          }else{
            maxindx = maxindx + 1;
          }
            i= i+1;
        }
      }
      let fieldName = "";
      if(namesList.length){
        fieldName = namesList.join(", ");
      }
      return fieldName;
    },
    updateMetadataProfileLstFromServer(isPageClick = false){
      let payload = {}
      let filterBy = {}
      this.$emit("searchFiltersUpdated", this.searchFilters);
      if(isPageClick){
        filterBy['page'] = this.page
      }
      if(typeof(this.searchFilters.name) != 'undefined' &&
      this.searchFilters.name.trim().length > 0){
        filterBy.name = this.searchFilters.name
      }
      if(typeof(filterBy) != 'undefined'){
        payload.params = filterBy
      }
      this.getAllMetadataProfilesFromServer(payload).then((data)=>{
        this.totalPages = data["page_count"];
        this.page = data["page"];
        this.totalProfiles = data["total_metadata_profiles"];
        this.perPage = data["metadata_profiles_per_page"];
        this.metadataProfileList = data.metadata_profiles
        if(Object.keys(data).includes("tag_info")){
          this.tagIdNameList = data.tag_info
        }else{
          this.tagIdNameList = [];
        }
        if(Object.keys(data).includes("category_info")){
          this.categoryIdNameList = data.category_info
        }else{
          this.categoryIdNameList = [];
        }
        if(Object.keys(data).includes("user_info")){
          this.userIdNameList = data.user_info
        }else{
          this.userIdNameList = [];
        }
        if(Object.keys(data).includes("user_group_info")){
          this.userGroupIdNameList = data.user_group_info
        }else{
          this.userGroupIdNameList = [];
        }
        this.selectedRowDetails = {}
      });
    },
    refreshStartupData(keyName){
      if(keyName == "screens"){
        if(Object.keys(this.getStartUpDataFromInCache()).includes("screens")){
        this.screenIdNameList = this.getStartUpDataFromInCache()["screens"];
        }
      }else if(keyName == "custom_metadatas"){
        if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
        this.fieldIdNameList = this.getStartUpDataFromInCache()["custom_metadatas"];
        }
      }
    },
    handleNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let entry_info = notification.message;
        if([NotifierConstants.fieldCreatedNotification].includes(notification.message_type)){
          setTimeout(()=>{
            this.refreshStartupData("custom_metadatas");
          }, 100);
        }else if([NotifierConstants.fieldModifiedNotification,
            NotifierConstants.fieldRemovedNotification,
            NotifierConstants.screenModifiedNotification,
            NotifierConstants.userModifiedNotification,
            NotifierConstants.userRemovedNotification,
            NotifierConstants.catalogModifiedNotification,
            NotifierConstants.catalogRemovedCreatedNotification,
            NotifierConstants.userGroupModifiedNotification,
            NotifierConstants.userGroupRemovedNotification].includes(notification.message_type)){
          setTimeout(()=>{
            if([NotifierConstants.fieldModifiedNotification,
                NotifierConstants.fieldRemovedNotification].includes(notification.message_type)){
              this.refreshStartupData("custom_metadatas");
            }
            if(NotifierConstants.screenModifiedNotification == notification.message_type){
              this.refreshStartupData("screens");
            }
            this.updateMetadataProfileLstFromServer(true);
          }, 100);
        }else if([NotifierConstants.screenProfileCreatedNotification].includes(notification.message_type)){
          if(this.page == 1){
            setTimeout(()=>{
              this.updateMetadataProfileLstFromServer(true);
            }, 100);
          }
        }else if([NotifierConstants.screenProfileModifiedNotification,
                  NotifierConstants.screenProfileRemovedNotification].includes(notification.message_type)){
          let fIndex = this.metadataProfileList.findIndex(item=>item._id == entry_info.metadata_profile_id);
          if(fIndex >= 0){
            setTimeout(()=>{
              this.refreshStartupData("custom_metadatas");
              this.updateMetadataProfileLstFromServer(true);
            }, 100);
          }
        }
      }
    },
    ...mapActions("tags", ["getTagInfoFromServer"]),
    ...mapGetters("tags", ["getTagsFromInCache"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapActions("metadataProfiles", ["getAllMetadataProfilesFromServer", "deleteExistingMetadataProfile"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
  },
  created() {
    if(this.getStartUpDataFromInCache() != undefined){
      this.refreshStartupData("screens");
      this.refreshStartupData("custom_metadatas");
    }
    this.updateMetadataProfileLstFromServer(true);
    this.addWSEventListener({
            eventname:[NotifierConstants.fieldModifiedNotification,NotifierConstants.fieldRemovedNotification,
                       NotifierConstants.screenModifiedNotification,
                       NotifierConstants.userModifiedNotification, NotifierConstants.userRemovedNotification,
                       NotifierConstants.catalogModifiedNotification, NotifierConstants.catalogRemovedCreatedNotification,
                       NotifierConstants.userGroupModifiedNotification, NotifierConstants.userGroupRemovedNotification,
                       NotifierConstants.screenProfileCreatedNotification,NotifierConstants.screenProfileModifiedNotification,NotifierConstants.screenProfileRemovedNotification],
            callback:this.handleNotification,
            parent:"ShowMetadataProfiles"})
  },
  beforeDestroy(){
    this.removeWSEventListener({
            eventname:[NotifierConstants.fieldModifiedNotification,NotifierConstants.fieldRemovedNotification,
                       NotifierConstants.screenModifiedNotification,
                       NotifierConstants.userModifiedNotification, NotifierConstants.userRemovedNotification,
                       NotifierConstants.catalogModifiedNotification, NotifierConstants.catalogRemovedCreatedNotification,
                       NotifierConstants.userGroupModifiedNotification, NotifierConstants.userGroupRemovedNotification,
                       NotifierConstants.screenProfileCreatedNotification,NotifierConstants.screenProfileModifiedNotification,NotifierConstants.screenProfileRemovedNotification],
            callback:this.handleNotification,
            parent:"ShowMetadataProfiles"})
  }
};
</script>


<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;


.activeclass {
  color: $active-blue;
}

.key-div{
  color:$dull-text-color;
}

.search-bar-comm-style {
  margin-top: 5px;
  display:inline-flex;
  .search-bar{
    background: $primary-background !important;
    height:40px;
    width: 250px !important;
    float: inline-start;
    padding-inline-start: 12px;
    margin: 0;
    margin-inline-end: 3%;  
    padding-bottom:2px;
    border: $border-color !important;
  }
}


.view-more{
  color: $text-color;
  margin-inline-start: 7px;
}

.view-more:hover{
  color: $active-blue;
}

// .table-scroll {
//   /*width:100%; */
//   height: 100%;
//   display: block;
//   empty-cells: show;
//   border: none!important;
//   /* Decoration */
//   border-spacing: 0;
//   border: 1px solid;
//   thead {
//     color: $dull-text-color !important;
//     position: relative;
//     display: block;
//     width: 100%;
//   }
//   tbody {
//     height:100%;
//     display: block;
//     position: relative;
//     width: 100%;
//     font-weight: 500;
//     overflow: auto;
//     max-height: calc(100vh - 150px);
//   }
// }


// .table-scroll tr {
//   width: 100%;
//   display: flex;
//   height:auto;
// }

// .table-scroll td,
// .table-scroll th {
//   flex-basis: 100%;
//   flex-grow: 2;
//   display: block;
//   padding: 1rem;
//   text-align: start;
// }


// .small-col {
//   flex-basis: 10%;
// }

.table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        // margin: 0px 15px;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th {
            position: sticky;
            top: 0;
            background: $primary-background;
            z-index: 9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr {
            height: 45px;
            }
            tr:hover{
                background: $bg-color-on-hover;
            }
        }
    }

    .table {
        th {
            border-top: none !important;
            padding:0 1rem !important;
        }
        td {
            border-top: none !important;
            padding:10px !important;
        }
    }

    th {
        border-top: none !important;
        padding:0 10px !important;
    }

    .table-cell-styles{
        td{
            padding:10px !important;
            vertical-align: text-top;
        }
    }

    .table-with-border {
        thead {
            border-bottom: $border-color;
        }
        tr {
            border-bottom: $border-color;
        }
    }

.small-col {
  flex-basis: 10%;
}

.comm-user-row:hover {
  background: $bg-color-on-hover;
  color: $active-blue;
  td:first-child {
    text-decoration: underline;
  }
}

.height-set-for-component {
  // height: calc(100% - 150px);
  height:100%;
}

table .more-actions-btn {
  visibility: hidden;
}
table tr:hover .more-actions-btn {
  visibility: visible;
}


.more-actions-div {
  position: absolute;
  height: 30px;
  width: 100px;
  padding: 6px;
  z-index: 99;
  border: $border-color;
  background: $primary-background;
  bottom: 0px;
  inset-inline-start:15%;
  ul {
    list-style-type: none;
    li {
      color: $text-color !important;
    }
    li:hover {
      color: $active-blue !important;
    }
  }
}


.border{
  border:$border-color !important;
}

.show-delete-icon:hover{
    position: relative;
    .parent-row-delete,  .parent-row-edit{
        visibility: visible;
    }
}

.parent-row-delete{
  inset-inline-end: 55px;
}

.parent-row-edit{
  inset-inline-end: 0px;
}
.parent-row-delete, .parent-row-edit{
    margin-inline-start: 3px;
    position: absolute;
    // inset-inline-end :0px;
    z-index: 1;
    background: #525252;
    border: 1px solid #262626;
    width: 55px;
    height: 44px;
    padding: 12px;
    top: 0px;
    border-radius: 4px;
    visibility: hidden;
    color: #fff;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.activestatus {
  color: $active-green-color !important;
}

// //pagination
::v-deep {
        .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-start;
            display:none;
            margin-inline-start:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }

  .multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background !important;
        border: $border-color !important;
    }
    .multiselect__option--highlight {
       background: $bg-color-on-hover !important;
    }
    .multiselect__content {
       background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color:$text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color  !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: 12px !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: 12px !important;
      width:40%;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: absolute;
        display: block;
        background: $text-color;
        width: 100%;
        max-height: 240px;
        overflow: auto;
        border: $secondary-border-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background!important;
    }
}

.primary-btn-style{
    width: 100%;
    text-align: end;
    button{
        height: 35px;
        width: 70px;
        font-size:14px;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}


.learn-about-text-styles{
  width: 200px !important;
  color:$learn-about-text-color;
  text-align: end;
  padding-inline-end: 17px;
  svg{
    margin-inline-end: 2px;
    margin-bottom: 3px;
  }
}

.learn-about-text-styles:hover{
  text-decoration: underline;
  color:$learn-about-text-color-hover;
}

.ellipsis-to-entry{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 65%;
    position: relative;
    inset-inline-start:2px;
}

.ellipsis-to-entry-temp{
   text-overflow: ellipsis;
    overflow: hidden;
    // white-space: nowrap;
    width: 65%;
    position: relative;
    inset-inline-start:2px;
}

</style>